import classNames from 'classnames';
import React from 'react';
import styles from './style.module.scss';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import LayoutIT from './LayoutIT';
import { BackArrowIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

export default function ViewInternalTransfer() {
    const navigate = useNavigate();
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, styles.cusContainer, 'text-start')}>
                <div className={classNames(styles.cusContainer)}>
                    <div className={classNames(styles.layoutPo)}>
                        <BackArrowIcon style={{ cursor: 'pointer' }} onClick={() => navigate(routeConstant.admin.internalTransfer.list.path)} />
                        <div className={classNames(styles.headingPo)}>
                            <LayoutIT />
                        </div>
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    );
}
